import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-percent-pill',
  templateUrl: './percent-pill.component.html',
  styleUrls: ['./percent-pill.component.scss'],
})
export class PercentPillComponent implements OnInit {
  @Input() percent: any;
  @Input() reverseColor = false;
  @Input() showUpDown = true;
  @Input() showPositive = false;
  @Input() showInfinity = false;

  constructor() {}

  ngOnInit(): void {}

  isNumber(val): boolean {
    if (typeof val === 'number') {
      this.percent = isFinite(parseFloat(val.toFixed(0))) ? parseFloat(val.toFixed(0)) : 0;
    }
    return typeof val === 'number';
  }
}
